// extracted by mini-css-extract-plugin
module.exports = {"testclass":"ProjectsContent_testclass__2dnNQ","is-current":"ProjectsContent_is-current__1sMFJ"};